import React, { Component } from "react";
import PropTypes from "prop-types";
import ContainerDimensions from "react-container-dimensions";
import { Box, Lead } from "rebass";
import { nest, sum, ascending, merge } from "d3";
import moment from "moment";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

class OrderChart extends Component {
  constructor(props) {
    super(props);
    const dataOrders =
      props.data && props.data.length > 0
        ? this.getDataOrders(props.data)
        : props.defaultData;
    this.state = {
      dataOrders: dataOrders
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.length > 0) {
      this.state = {
        dataOrders: this.getDataOrders(nextProps.data)
      };
    } else {
      this.state = {
        dataOrders: nextProps.defaultData
      };
    }
  }

  getDataOrders = data => {
    const newDataOrders = merge([data, this.props.defaultData]);
    let dataOrders = nest()
      .key(function(d) {
        return moment(d.date).format("YYYY-MM-DD");
      })
      .sortKeys(ascending)
      .rollup(function(view) {
        return sum(view, function(d) {
          return d.qty;
        });
      })
      .entries(newDataOrders)
      .map(function(group) {
        let merged = { date: group.key, qty: group.value };
        return merged;
      });
    return dataOrders;
  };
  render() {
    const { dataOrders } = this.state;

    return (
      <Box w={[1]} p={[1]}>
        <Box w={[1]} p={[2]}>
          <Lead>Orders</Lead>
        </Box>
        <ContainerDimensions>
          {({ width, height }) => {
            let mainWidth = width - 50;
            let mainHeight = mainWidth / 2;
            if (width < 600) {
              // mainWidth = 800;
              mainHeight = mainWidth / 1.8;
            }
            return (
              <LineChart
                width={mainWidth}
                height={mainHeight}
                data={dataOrders}
                margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
              >
                <XAxis dataKey="date" />
                <YAxis
                  label={{
                    value: "Quantity",
                    angle: -90,
                    position: "insideLeft"
                  }}
                />
                <CartesianGrid strokeDasharray="3 3" />
                <Tooltip />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="qty"
                  stroke="#FF9900"
                  activeDot={{ r: 8 }}
                />
              </LineChart>
            );
          }}
        </ContainerDimensions>
      </Box>
    );
  }
}

OrderChart.propTypes = {
  data: PropTypes.array,
  defaultData: PropTypes.array.isRequired
};

OrderChart.defaultProps = {
  data: [],
  defaultData: []
};

export default OrderChart;



// WEBPACK FOOTER //
// ./src/campaigns/chart/OrderChart.js